import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaDropdown from './VaDropdown.vue'

export const VaDropdown = withConfigTransport(_VaDropdown)
export { VaDropdownContent } from './components/VaDropdownContent'
